import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { MsalGuard } from '@azure/msal-angular';
import { authenticationGuard } from './auth/guards/auth-guard';

export const APP_ROUTES: Routes = [
    {
        path: '',
        data: { title: 'page-titles.home' },
        component: HomeComponent,
        canActivate: [MsalGuard, authenticationGuard()]
    },
    {
        path: 'dashboard',
        canActivateChild: [MsalGuard, authenticationGuard()],
        loadChildren: () => import('./dashboard/dashboard.routes').then(r => r.DASHBOARD_ROUTES)
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes').then(r => r.AUTH_ROUTES)
    },
    {
        path: '**',
        redirectTo: ''
    }
];
